export default {
  'dept.edit.update.title': 'Update department',
  'dept.edit.add.title': 'Add department',
  'dept.edit.update.success': 'Update success',
  'dept.edit.add.success': 'Add success',
  'dept.edit.form.parentId': 'Parent department',
  'dept.edit.form.parentId.placeholder': 'Please select the parent department',
  'dept.edit.form.deptName': 'Department name',
  'dept.edit.form.deptName.placeholder': 'Please enter the department name',
  'dept.edit.form.deptName.required': 'Please enter the department name',
  'dept.edit.form.status': 'Status',
  'dept.edit.form.status.normal': 'Normal',
  'dept.edit.form.status.disabled': 'Disabled',
  'dept.edit.form.status.required': 'Please select the department status',
  'dept.edit.form.sortNum': 'Sort',
  'dept.page.query.form.deptName': 'Department name',
  'dept.page.query.form.deptName.placeholder': 'Please enter the department name',
  'dept.page.query.expandAll': 'Expand all',
  'dept.page.query.collapseAll': 'Collapse all',
  'dept.page.query.add': 'Add department',
  'dept.page.column.deptName': 'Department name',
  'dept.page.column.status': 'Status',
  'dept.page.column.status.normal': 'Normal',
  'dept.page.column.status.disabled': 'Disabled',
  'dept.page.column.sortNum': 'Sort',
  'dept.page.column.operation': 'Operation',
  'dept.page.delete.confirm.message': 'Are you sure to delete "{deptName}" and all departments under it?',
  'dept.page.delete.success': 'Delete success'
}
